





























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import TasksDisplay from './TasksDisplay.vue';
import NoData from '../gateways/views/NoData.vue';
import {
  PaginatedListOfMilestones,
  PaginatedListOfTasks,
  Project,
  SourceVisitor,
} from 'ganttlab-entities';

@Component({
  components: {
    TasksDisplay,
    NoData,
  },
})
export default class MilestonesDisplay extends Vue {
  @Prop() private activeMilestone!: number;
  @Prop() private paginatedMilestones!: PaginatedListOfMilestones;
  @Prop() private paginatedTasks!: PaginatedListOfTasks;
  @Prop() readonly project!: Project | null;
  @Prop() readonly sourceUrl!: string | null;
  @Prop() readonly viewGateway!: SourceVisitor<unknown> | null;

  @Emit('set-active-milestone')
  setActiveMilestone(index: number) {
    return index;
  }

  @Emit('set-milestones-page')
  setMilestonesPage(page: number) {
    return page;
  }

  @Emit('set-tasks-page')
  setTasksPage(page: number) {
    return page;
  }

  get previousPage(): number | null {
    if (this.paginatedMilestones && this.paginatedMilestones.previousPage) {
      return this.paginatedMilestones.previousPage;
    }
    return null;
  }

  get currentPage(): number | null {
    if (this.paginatedMilestones && this.paginatedMilestones.page) {
      return this.paginatedMilestones.page;
    }
    return null;
  }

  get nextPage(): number | null {
    if (this.paginatedMilestones && this.paginatedMilestones.nextPage) {
      return this.paginatedMilestones.nextPage;
    }
    return null;
  }

  get lastPage(): number | null {
    if (this.paginatedMilestones && this.paginatedMilestones.lastPage) {
      return this.paginatedMilestones.lastPage;
    }
    return null;
  }
}
